export default ( pathname ) => {
    return pathname !== '/' && !pathname.startsWith('/work');
}